import { render, staticRenderFns } from "./FichaClinicaFinalizar.vue?vue&type=template&id=db3ec436&scoped=true&"
import script from "./FichaClinicaFinalizar.vue?vue&type=script&lang=js&"
export * from "./FichaClinicaFinalizar.vue?vue&type=script&lang=js&"
import style0 from "./FichaClinicaFinalizar.vue?vue&type=style&index=0&id=db3ec436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3ec436",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VImg,VRow})
